var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('layout-default',{staticClass:"Unauthorized"},[_c('div',{staticClass:"unauthorized-container"},[_c('h1',[_vm._v("Din bruker har ikke tilgang til denne delen av applikasjonen.")])])])}
var staticRenderFns = []

export { render, staticRenderFns }